import { ChangedResource } from '@lmc/ts-common/lib/utils/rota-socket-response'
import {
  INSTANCES_QUERY_KEY,
  INSTANCE_QUERY_KEY,
  RESIDENTS_QUERY_KEY,
  REVISIONS_QUERY_KEY,
  REVISION_QUERY_KEY,
  ROTA_PATTERN_QUERY_KEY,
  USERS_QUERY_KEY,
} from 'screens/Rostering/hooks/queryConstants'

export const resourceToQueryKeyMap = {
  [ChangedResource.Instances]: [INSTANCE_QUERY_KEY, INSTANCES_QUERY_KEY],
  [ChangedResource.Revisions]: [REVISION_QUERY_KEY, REVISIONS_QUERY_KEY],
  [ChangedResource.Patterns]: [ROTA_PATTERN_QUERY_KEY],
  [ChangedResource.Residents]: [RESIDENTS_QUERY_KEY],
  [ChangedResource.Users]: [USERS_QUERY_KEY],
}
